<template>
  <v-container>
    <rest-resource-table
      label="Qualification Options"
      resource-name="quals"
      resource-id-name="qualid"
      @saved="$store.dispatch('LOAD_CONFIG')"
      allow-new
      allow-delete
      edit-permission="editQualifications"
    >
      <template v-slot:item.inactive="{ item }">
        <div>
          <v-simple-checkbox
            disabled
            :value="item.inactive"
          ></v-simple-checkbox>
        </div>
      </template>
      <template v-slot:item.countryid="{ item }">
        <div>
          {{ $store.getters.lookup("Country", item.countryid || 0) || "" }}
        </div>
      </template>
      <template v-slot:item.overseas="{ item }">
        <div>
          <v-simple-checkbox
            disabled
            :value="item.overseas"
          ></v-simple-checkbox>
        </div>
      </template>
      <template v-slot:item.inactivenz="{ item }">
        <div>
          <v-simple-checkbox
            disabled
            :value="item.inactivenz"
          ></v-simple-checkbox>
        </div>
      </template>
      <template v-slot:form="{ item }">
        <div>
          <v-text-field label="Name" v-model="item.name"></v-text-field>
          <lookup-select
            lookup-name="Country"
            label="Country"
            v-model="item.countryid"
          ></lookup-select>
          <v-checkbox label="inactive" v-model="item.inactive"></v-checkbox>
          <v-checkbox label="overseas" v-model="item.overseas"></v-checkbox>
          <v-checkbox label="inactivenz" v-model="item.inactivenz"></v-checkbox>
        </div>
      </template>
    </rest-resource-table>
  </v-container>
</template>

<script>
import restResourceTable from "@/components/lib/RestResourceTable.vue";
export default {
  name: "ScopesOfPracticeOptions",
  components: {
    restResourceTable
  },
  data() {
    return {
      columnHeaders: [
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Scope Code",
          value: "dmScopecode"
        },
        {
          text: "Inactive",
          value: "inactive"
        }
      ]
    };
  }
};
</script>
